import { Component } from '@angular/core';
import { deserialize, serialize, Type } from 'class-transformer';
import { InjectorHelper } from '../../../helpers/injector.helper';
import { WorkflowModuleExecuter, WorkflowStatus } from '../../../models/workflow/workflow.model';
import { ConfigService } from '../../../services/config.service';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../services/workflow.service';
import { WorkflowDialogContent } from '../../workflow.dialog';
import { PropertySetting } from '../readProperty/read.multi.property.settings';

@Component({
    selector: 'get-system-informations-wf-settings',
    templateUrl: './get.system.informations.settings.html'
})
export class GetSystemInformationsSettings extends WorkflowDialogContent {
    Data = new GetSystemInformationsSettingsData();
    Properties = [
        {
            Caption: '@@Client URL',
            Value: 'ExternalClientUrl'
        },
        {
            Caption: '@@Service URL',
            Value: 'ExternalServerUrl'
        }
    ]

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'getSystemInformationsWFModule';
        reg.Caption = '@@Systeminformationen auslesen';
        reg.GroupID = 'generateData';
        reg.Index = 100;
        reg.SettingsControl = GetSystemInformationsSettings;
        reg.SettingsTypeHelper = new GetSystemInformationsSettingsDataHelper();
        reg.Executer = GetSystemInformationsModuleExecuter;
        return reg;
    }

    initialize(data: any) {
        if (data) {
            const json = serialize(data);
            this.Data = deserialize(GetSystemInformationsSettingsData, json);
        }
    }

    getResult() {
        const values = [];
        this.Data.Properties.forEach(x => {
            if (x.PropName && (x.StatusKey || x.UseForState)) {
                values.push(x);
            }
        });
        this.Data.Properties = values;
        return this.Data;
    }

    useForStateChecked(ev, col) {
        if (ev && ev.checked && this.Data && this.Data.Properties) {
            this.Data.Properties.forEach(x => {
                x.UseForState = false;
            });
            col.UseForState = true;
        }
    }

    addValue() {
        if (this.Data) {
            if (this.Data.Properties) {
                this.Data.Properties.push(new PropertySetting());
            } else {
                this.Data.Properties = [new PropertySetting()];
            }
        }
    }

    removeValue(i) {
        if (this.Data && this.Data.Properties) {
            this.Data.Properties.splice(i, 1);
        }
    }
}

// @dynamic
export class GetSystemInformationsSettingsData {
    @Type(() => PropertySetting)
    Properties: PropertySetting[] = [];
}

export class GetSystemInformationsSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }

    getEmptySettingsInstance() {
        return new GetSystemInformationsSettingsData();
    }

    async fillActualState(module, state, wfData) {
        if (state) {
            const settings = WorkflowModuleSettingsHelper.GetSettingsFromModule(module);
            if (settings && settings.Properties) {
                const list = [];
                settings.Properties.forEach(x => {
                    if (x.StatusKey) {
                        list.push(x.StatusKey);
                    }
                });
                WorkflowModuleSettingsHelper.AddStatusKeysToState(state, list);
            }
        }
    }
}

export class GetSystemInformationsModuleExecuter extends WorkflowModuleExecuter {
    async execute(status: WorkflowStatus): Promise<number> {
        return new Promise<number>(resolve => {
            if (status.ActualSettings) {
                if (status.ActualSettings.Properties && status.ActualSettings.Properties.length > 0) {
                    const query = { Properties: [] };
                    status.ActualSettings.Properties.forEach(x => {
                        query.Properties.push(x.PropName);
                    });
                    const service = InjectorHelper.InjectorInstance.get<ConfigService>(ConfigService);
                    service.GetConfigProperties(query).subscribe(result => {
                        if (result) {
                            status.ActualSettings.Properties.forEach(x => {
                                const val = result[x.PropName];
                                if (x.StatusKey) {
                                    status.Context.set(x.StatusKey, val);
                                }
                                if (x.UseForState === true) {
                                    status.ActualParameter = val;
                                }
                            });
                        }
                        resolve(0);
                    });
                } else {
                    status.Logger.logError('GetSystemInformations modul: No properties found.');
                    resolve(super.execute(status));
                }
            } else {
                status.Logger.logError('GetSystemInformations modul: No settings found.');
                resolve(super.execute(status));
            }
        });
    }
}
